export default __webpack_public_path__ + "static/media/AKM_2.11721e9b.png";